import type { RouteObject } from "react-router-dom";
import AppRoot from "@/components/feature/AppRoot";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import Login from "@/pages/login/page";
import Calculadora from "@/pages/calculadora/page";
import Tabelas from "@/pages/tabelas/page";
import Cotacoes from "@/pages/cotacoes/page";
import Indicadores from "@/pages/indicadores/page";
import TabelaPrecos from "@/pages/tabela-precos/page";
import Usuarios from "@/pages/usuarios/page";
import AlterarSenha from "@/pages/alterar-senha/page";
import Perfil from "@/pages/perfil/page";
import UnifiedRequestsPage from "@/features/requests/UnifiedRequestsPage";
import { Navigate } from "react-router-dom";
import AdminOnly from "@/components/feature/AdminOnly";

const routes: RouteObject[] = [
  {
    element: <AppRoot />,
    children: [
      {
        path: "/login",
        element: <Login />,
      },
      { path: "/alterar-senha", element: <AlterarSenha /> },
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/calculadora",
        element: <Calculadora />,
      },
      {
        path: "/tabelas",
        element: <Tabelas />,
      },
      { path: "/clientes", element: <Tabelas /> },
      { path: "/produtos", element: <Tabelas /> },
      { path: "/usuarios", element: <Usuarios /> },
      {
        path: "/tabela-precos",
        element: <TabelaPrecos />,
      },
      {
        path: "/cotacoes",
        element: <Cotacoes />,
      },
      {
        path: "/indicadores",
        element: <Indicadores />,
      },
      { path: "/solicitacoes", element: <AdminOnly><UnifiedRequestsPage /></AdminOnly> },
      { path: "/amostras", element: <AdminOnly><Navigate to="/solicitacoes" replace /></AdminOnly> },
      { path: "/projetos", element: <AdminOnly><Navigate to="/solicitacoes" replace /></AdminOnly> },
      { path: "/perfil", element: <Perfil /> },
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
];

export default routes;
